import React from 'react';
import { GenericOverlayError } from '../../../fallback-screens/components/overlay-errors/OverlayErrors';
import styles from '../../../fallback-screens/components/overlay-errors/OverlayErrors.module.scss';

export function UserConsentError({
  isTransformationView = false
}: {
  isTransformationView?: boolean;
}) {
  return (
    <GenericOverlayError
      title='User Consent not available 😢'
      description={`Hevo support team does not have access to view data.
      Ask the user to grant access from Data & Privacy in Team's Tab, and try again.`}
      descriptionClassName={isTransformationView ? 'mx-6' : ''}
    />
  );
}
